module.exports = __webpack_public_path__ + "img/fig24.b4b447cb.jpg";